module.exports = __webpack_public_path__ + "static/media/icon_new-entry.96632f8a.svg";